<template>
  <div>
    <el-row :gutter="10">
      <el-col :span="24">
        <div style="font-weight: bold; margin-top: 10px;">{{ $t('orderCenterCont.DownloadTemplate') }}</div>
        <div ref="download1" style="margin-bottom: 20px;">
          <span style="cursor: pointer" @click="initDown()">
            <span style="color:#00A551;">批量取消CTe发票模板(Modelo de Cancelamento em Lote de CT-e).xlsx</span>
            <span class="el-icon-download" style="color:#00A551;margin-left: 20px" />
          </span>
        </div>
      </el-col>
      <el-col :span="24">
        <div style="font-weight: bold; margin-top: 10px;">{{ $t('basicData.UploadTheFile') }}</div>
        <el-upload
          ref="demoUpload"
          :before-upload="beforeUpload"
          :limit="1"
          :file-list="fileList"
          :on-exceed="handleExceed"
          :on-remove="handleRemove"
          :http-request="uploadFile"
          action
          class="upload-demo"
          drag
          multiple
        >
          <i class="el-icon-plus" style="margin: 50px auto 20px;" />
          <!-- 点击或拖拽文件到此处上传 -->
          <div class="el-upload__text">{{ $t('orderImport.cldrUpload') }}</div>
          <!--请上传 .xlsx, .xls 文件-->
          <div class="el-upload__text">{{ $t('basicData.PleaseUploadExcelFiles') }}</div>
        </el-upload>
      </el-col>
      <el-col :span="24">
        <!--取消原因类型-->
        <div style="font-weight: bold; margin-top: 10px;">{{ $t('mdfeTranslate.CancellationReasonType') }}</div>
        <div>
          <el-select v-model="cancelReasonType" :placeholder="$t('GlobalSetObj.pleaseChoose')">
            <el-option key="0" :label="$t('mdfeTranslate.BillingError')" :value="1" /><!--计费错误-->
            <el-option key="1" :label="$t('mdfeTranslate.IncorrectRule')" :value="2" /><!--规则有误-->
            <el-option key="2" :label="$t('basicData.other')" :value="0" /><!--其他-->
          </el-select>
        </div>
      </el-col>
    </el-row>
    <!--批量取消结果-->
    <el-dialog
      :title="$t('mdfeTranslate.BatchCancelResult')"
      :visible.sync="showBatchCancelResult"
      width="600px"
      :modal-append-to-body="true"
      :append-to-body="true"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div style="padding: 20px 0">
        <div v-if="percentage >= 100" style="display: flex;margin-bottom: 20px;">
          <div style="flex: 1">{{ $t('organizationManage.all') }}：{{ excelJsonData.length }}</div>
          <div style="flex: 1">{{ $t('organizationManage.succeed') }}：{{ successCount }}</div>
          <div style="flex: 1">{{ $t('operationCenter.fail') }}：{{ failCount }}</div>
        </div>
        <el-progress
          :text-inside="true"
          text-color="#fff"
          :stroke-width="26"
          :percentage="percentage"
        />
        <div v-if="percentage >= 100" style="margin-top: 20px;">
          <div ref="download1" style="margin-bottom: 20px;">
            <div style="margin-bottom: 10px;">{{ $t('mdfeTranslate.BatchCancelResult') }}：</div>
            <span style="cursor: pointer" @click="downloadResult()">
              <span style="color:#00A551;">批量取消CTe发票(Cancelamento em lote de faturas CT-e).xlsx</span>
              <span class="el-icon-download" style="color:#00A551;margin-left: 20px" />
            </span>
          </div>
        </div>
      </div>
      <div v-if="percentage >= 100" slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="confirmClose">{{ $t('collectionCenter.close') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as XLSX from 'xlsx';
import ExcelJs from 'exceljs';
import { saveAs } from 'file-saver';
import { cancelCteInvoice } from '@/api/invoiceCenter';
export default {
  data() {
    return {
      fileList: [],
      excelJsonData: [],
      headKey: {
        '包裹号(Número da Encomenda)': 'packageNo',
        '发票密钥(Chave de Acesso da Nota Fiscal)': 'invoiceKey'
      },
      successCount: 0,
      failCount: 0,
      showBatchCancelResult: false,
      percentage: 0,
      allResult: [],
      cancelReasonType: null
    };
  },
  methods: {
    // 下载模板
    initDown() {
      const a = document.createElement('a');
      a.href = '/static/批量取消CTe发票模板(Modelo de Cancelamento em Lote de CT-e).xlsx';
      a.download = '批量取消CTe发票模板(Modelo de Cancelamento em Lote de CT-e)';
      a.style.display = 'none';
      this.$nextTick(() => {
        this.$refs.download1.appendChild(a);
      });
      a.click();
      a.remove();
    },
    // 文件上传格式、大小限制
    beforeUpload(file) {
      const fileSuffix = file.name.substring(file.name.lastIndexOf('.') + 1);
      const whiteList = ['xls', 'xlsx'];
      if (whiteList.indexOf(fileSuffix) === -1) {
        // 上传文件只能是xlsx格式
        this.$message.error(this.$t('collectionCenter.uploadOnlyXlsx'));
        return false;
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        // 上传文件大小不能超过 2MB
        this.$message.error(this.$t('collectionCenter.uploadNot2MB'));
        return false;
      }
    },
    // 上传数量限制
    handleExceed() {
      this.$message.error(this.$t('basicData.Only1FileCanBeUploadedAtATime'));
    },
    // 删除文件
    handleRemove() {
      this.fileList = [];
      this.excelJsonData = [];
    },
    // 文件上传
    uploadFile(option) {
      const file = option.file;
      this.parseExcelToJson(file);
    },
    // 解析Excel文件为JSON对象数组，格式为[{表头：value}]
    parseExcelToJson(file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array' });

          // 获取第一个工作表
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];

          // 将工作表直接转换为JSON对象数组，格式为[{表头：value}]
          const jsonData = XLSX.utils.sheet_to_json(worksheet);
          this.excelJsonData = jsonData.map(item => {
            const transformedItem = {};
            for (const [originalKey, value] of Object.entries(item)) {
              transformedItem[this.headKey[originalKey]] = value;
            }
            return transformedItem;
          });
        } catch (error) {
          this.$message.error(error.message);
        }
      };
      reader.readAsArrayBuffer(file);
    },
    // 提交
    async confirmSaveData() {
      if (this.cancelReasonType === null || this.cancelReasonType === '' || this.cancelReasonType === undefined) {
        this.$message.error(this.$t('mdfeTranslate.PleaseSelectCancellationReasonType'));
        return;
      }
      if (this.excelJsonData.length === 0) {
        this.$message.error(this.$t('basicData.PleaseUploadExcelFiles'));
      } else {
        this.showBatchCancelResult = true;
        try {
          // 使用并发控制处理请求
          const concurrencyLimit = 10; // 最大并发数
          this.allResult = [];
          this.successCount = 0;
          this.failCount = 0;

          // 创建一个执行单个请求的函数
          const processItem = async(item) => {
            item['cancelReasonType'] = this.cancelReasonType;
            try {
              const res = await cancelCteInvoice(item, false);
              const result = {
                invoiceKey: item.invoiceKey,
                orderNumber: item.packageNo,
                msg: res.data.msg,
                status: res.data.code,
                statusStr: res.data.code === 200 ? '成功(Sucesso)' : '失败(Falha)'
              };

              if (result.status === 200) {
                this.successCount++;
              } else {
                this.failCount++;
              }
              return result;
            } catch (error) {
              this.failCount++;
              return {
                invoiceKey: item.invoiceKey,
                orderNumber: item.packageNo,
                msg: error.data?.msg || error.message,
                status: error.data?.code || 500,
                statusStr: '失败(Falha)'
              };
            }
          };

          // 使用并发控制处理所有请求
          for (let i = 0; i < this.excelJsonData.length; i += concurrencyLimit) {
            const batch = this.excelJsonData.slice(i, i + concurrencyLimit);
            const batchPromises = batch.map(item => processItem(item));
            const batchResults = await Promise.all(batchPromises);
            this.allResult = this.allResult.concat(batchResults);

            // 更新进度
            this.percentage = parseInt((i + batch.length) / this.excelJsonData.length * 100);

            // 给浏览器时间处理其他任务
            await new Promise(resolve => setTimeout(resolve, 0));
          }
        } catch (error) {
          this.$message.error(error.message);
        }
      }
    },
    // 下载取消结果
    downloadResult() {
      const that = this;
      const ddd = async() => {
        const wb = new ExcelJs.Workbook();
        const Sheet1 = wb.addWorksheet('Sheet1');
        Sheet1.columns = [
          {
            header: '包裹号(Número da Encomenda)',
            key: 'orderNumber',
            width: 30
          },
          {
            header: '发票密钥(Chave de Acesso da Nota Fiscal)',
            key: 'invoiceKey',
            width: 50
          },
          {
            header: '状态(Estado)',
            key: 'statusStr',
            width: 30
          },
          {
            header: '失败原因(Razões do fracasso)',
            key: 'msg',
            width: 50
          }
        ];
        const Sheet1_data = [];
        that.allResult.map((item) => {
          Sheet1_data.push({
            orderNumber: item.orderNumber,
            invoiceKey: item.invoiceKey,
            statusStr: item.statusStr,
            msg: item.msg
          });
        });
        Sheet1.addRows(Sheet1_data);
        const buffer = await wb.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
          type: 'application/octet-stream'
        });
        const saveName = '批量取消CTe发票(Cancelamento em lote de faturas CT-e).xlsx'; // '揽收装车记录.xlsx'
        saveAs(blob, saveName);
      };
      ddd();
    },
    // 关闭
    confirmClose() {
      this.showBatchCancelResult = false;
      this.successCount = 0;
      this.failCount = 0;
      this.percentage = 0;
      this.fileList = [];
      this.excelJsonData = [];
      this.$emit('closeCancelWindow', true);
    }
  }
};
</script>

<style scoped>

</style>
